import React, { lazy } from 'react';
import { CaseStudiesSection } from './CaseStudiesSection';
export const ThankYou = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-239">
      <div className="text-center max-w-2xl mx-auto px-4 pt-20 pb-12" data-id="element-240">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nVj75GpuHF5NXayhnfyMrJ/Logo-02-01.png" alt="Ikigai Real Estate" className="h-32 md:h-40 mx-auto mb-8" data-id="element-241" />
        <h1 className="text-xl md:text-2xl font-bold mb-6" data-id="element-242">
          DISCLAIMER: YOUR CALL IS NO YET CONFIRMED. PLEASE WATCH THE SHORT
          VIDEO BELOW FOR NEXT STEPS
        </h1>
        <div style={{
        position: 'relative',
        paddingTop: '56.25%'
      }} data-id="element-243">
          <iframe src="https://iframe.mediadelivery.net/embed/478913/adefa044-dcb0-4bcb-bdbb-b390ff349442?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
          border: 0,
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%'
        }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-244"></iframe>
        </div>
        <p className="text-lg md:text-xl text-gray-700 mt-8 mb-8" data-id="element-245">
          Please check the email you used to schedule for your call
          confirmation.
        </p>
      </div>
      <CaseStudiesSection data-id="element-246" />
      <div className="text-center py-8 bg-primary text-white" data-id="element-247">
        <p data-id="element-248">© 2025 https://ikigaire.ae. All rights reserved.</p>
      </div>
    </div>;
};